import { render, staticRenderFns } from "./group-details.vue?vue&type=template&id=4f5aad62"
import script from "./group-details.vue?vue&type=script&lang=js"
export * from "./group-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports